import React, { Component } from "react";
import produce from "immer";
import _ from "lodash";

export default class ViewMeta extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
      goal: "",
      round: "",
      starsTable: []
    };
  }

  componentDidMount() {
    const { meta } = this.props || {};

    if (!_.isEmpty(meta)) {
      this.setState(
        produce(draft => {
          draft = meta;
          return draft;
        })
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { meta: prevMeta } = prevProps;
    const { meta: currMeta } = this.props;
    if (!_.isEqual(prevMeta, currMeta)) {
      this.setState(
        produce(draft => {
          draft = currMeta;
          return draft;
        })
      );
    }
  }

  handleChange = e => {
    const { value, name } = e.target;
    this.setState(
      produce(draft => {
        draft[name] = Number.parseInt(value);
      })
    );
  };

  handleStarsChange = e => {
    const { value, name } = e.target;
    this.setState(
      produce(draft => {
        draft[name] = Number.parseInt(value);
      })
    );
  };

  handleSubmit = e => {
    e.preventDefault();
    console.log("submit");
    // const { id, pw } = this.state;
    // this.props.authLogin(id, pw);
    // this.setState((prevState, props) => ({
    //   id: "",
    //   pw: ""
    // }));
  };

  render() {
    const { title, goal, round, starsTable } = this.state;
    return (
      <form
        onSubmit={this.handleSubmit}
        className="row mx-auto"
        style={{ maxWidth: 600 }}
      >
        {/* TITLE */}
        {/* <div className="col-12 d-flex justify-content-between align-items-center my-1">
          <label>타이틀</label>
          <input
            type="text"
            name="title"
            value={title}
            onChange={this.handleChange}
            readOnly
          />
        </div> */}

        {/* GOAL */}
        <div className="col-12 d-flex justify-content-between align-items-center my-1">
          <label>목표</label>
          <input
            type="text"
            name="goal"
            value={goal}
            onChange={this.handleChange}
            // readOnly
          />
        </div>

        {/* ROUND */}
        <div className="col-12 d-flex justify-content-between align-items-center my-1">
          <label>기회</label>
          <input
            type="text"
            name="round"
            value={round}
            onChange={this.handleChange}
            // readOnly
          />
        </div>

        {/* STARS TABLE */}
        <div className="col-12 d-flex justify-content-between align-items-center my-1">
          <label>채점 가중치(백분율, 수정 불가)</label>
          <input
            type="text"
            name="starsTable"
            value={starsTable}
            onChange={this.handleChange}
            readOnly
          />
        </div>

        {/* SUBMIT */}
        <div className="col-12 d-flex justify-content-between align-items-center my-1">
          <button type="submit" className="btn btn-danger btn-block" disabled>
            개발 중... 확인만 가능
          </button>
        </div>
      </form>
    );
  }
}
